import { useEffect } from 'react';
import { RachelPageContext } from '../rachelPageContext.types';
import { useRachelStore } from '../store/rachel.store';
import { selectRachelDismissedPageContext } from '../store/rachel.store.selectors';
import { isSameAttachedPage } from './useRachelChat.utils';

export const useRachelPageContextDismissal = (currentPageContext: RachelPageContext) => {
  const dismissedPageContext = useRachelStore(selectRachelDismissedPageContext);

  const isPageContextDismissed = isSameAttachedPage(dismissedPageContext, currentPageContext);
  const hasStaleDismissal = !!dismissedPageContext && !isPageContextDismissed;

  useEffect(() => {
    if (hasStaleDismissal) {
      useRachelStore.getState().setDismissedPageContext(null);
    }
  }, [hasStaleDismissal]);

  return {
    isPageContextDismissed,
    dismissPageContext: () => useRachelStore.getState().setDismissedPageContext(currentPageContext),
  };
};
